import { render, staticRenderFns } from "./order-create.vue?vue&type=template&id=12f3008e&scoped=true&"
import script from "./order-create.vue?vue&type=script&lang=js&"
export * from "./order-create.vue?vue&type=script&lang=js&"
import style0 from "./order-create.vue?vue&type=style&index=0&id=12f3008e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3008e",
  null
  
)

export default component.exports